import React, { Component } from 'react';

import Input from './Input';

class Autocomplete extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showList: false,
			showListItems: [],
			activeItem: -1
		}

		this.activeItemElement = null;
		this.listSize = (this.props.listSize * 1) || 5;

		this.onChange = this.onChange.bind(this);
		this.onFocus = this.onFocus.bind(this);
		this.onBlur = this.onBlur.bind(this);
		this.clickItem = this.clickItem.bind(this);
		this.onKeyDown = this.onKeyDown.bind(this);
		this.hoverItem = this.hoverItem.bind(this);
		this.updateList = this.updateList.bind(this);
	}

	updateList(value) {
		let listLength = this.props.options.length;
		let tempShowList = true;
		let tempShowListItems = [];
		let tempSelectedId = null;
		let tempIsNew = true;

		for(let i=0; i < listLength; i++) {
			let optionText = this.props.options[i].text.toUpperCase();
			if(optionText.indexOf(value.toUpperCase()) === 0) {
				tempShowListItems.push(this.props.options[i]);
			}
			if(optionText === value.toUpperCase()) {
				tempSelectedId = this.props.options[i].value;
				tempIsNew = false;
			}
			if(tempShowListItems.length === this.listSize) {
				break;
			}
		}

		if(tempShowListItems.length === 0) {
			tempShowList = false
		}
		// if the value is empty, hide list and let parent know its empty
		if(value === '') {
			if( !this.props.showListOnEmpty) {
				tempShowList = false;
			}
			tempSelectedId = null;
		}

		this.setState({
			showList: tempShowList,
			showListItems: tempShowListItems
		});

		this.props.onChange({
			selectedId: tempSelectedId,
			selectedText: value
		});
	}


		onBlur(e) {
			this.setState({
				showList: false
			});
			// setTimeout(
		  //   function() {
			// 	this.setState({
			// 		showList: false
			// 	});
		  //   }
		  //   .bind(this),
		  //   200
			// );
		}

	onFocus(e) {
		let value = e.target.value;

		if(value.length === 0 && !this.props.showListOnEmpty) {
			this.setState({
				showList: false
			});
		} else {
			this.setState({
				showList: true
			});
		}

		this.updateList(value);
	}

	onChange(e) {
		let value = e.target.value;

		if(value.length === 0 && !this.props.showListOnEmpty) {
			this.setState({
				showList: false,
			});
		} else {
			this.setState({
				showList: true,
			});
		}

		this.updateList(value);
	}

	onKeyDown(e) {
		let key = (e.keyCode || e.which),
			down = 40,
			up = 38,
			enter = 13,
			target = e.target,
			activeItem = this.state.activeItem;

		switch (key) {
			case down:
				if (activeItem < (this.listSize - 1)) {
					activeItem += 1;
					this.setState({
						activeItem: activeItem
					});
				}
				e.preventDefault();
				break;

			case up:
				if (activeItem > 0) {
					activeItem -= 1;
					this.setState({
						activeItem: activeItem
					});
				}
				e.preventDefault();
				break;

			case enter:
				e.preventDefault();
				if (activeItem > -1) {
					// TODO: this would ideally trigger a mousedown event on the active item
					this.clickItem({target: this.activeItemElement});
				}

				break;
		}
	}

	hoverItem(e) {
		let target = e.target,
			activeItem = (e.target.dataset.index * 1);

		this.setState({
			activeItem: activeItem
		});
	}

	clickItem(e) {
		let item = e.target;

		this.activeItemElement = item;

		this.props.onChange({
			selectedId: item.dataset.value,
			selectedText: item.innerText
		});

		this.setState({
			showList: false
		});
	}

	render() {
			const { showList, showListItems } = this.state;

			return (
					<div className="pp-autocomplete" key={this.state.key}>
							<Input
									type="text"
									label={this.props.label}
									htmlID={this.props.htmlID}
									htmlName={this.props.htmlName}
									className={"pp-input-text " + (this.props.className ? this.props.className : '')}
									value={this.props.selectedText || ''}
									placeholderText={this.props.placeholderText}
									onChange={this.onChange}
									onFocus={this.onFocus}
									onBlur={this.onBlur}
									onKeyDown={this.onKeyDown}
									maxLength={this.props.maxLength}
									disabled={this.props.disabled}
									required={this.props.required}
									error={this.props.error || false}
							/>
						<div className={"pp-autocomplete-results " + (showList ? "pp-show" : "")}>
								{showListItems &&
									showListItems.map((option, index) => (
										<p
											className={"pp-result " + (index === this.state.activeItem ? "pp-active" : '')}
											ref={(index === this.state.activeItem ? element => this.activeItemElement = element : '')}
											key={option.value}
											data-index={index}
											data-value={option.value}
											onMouseDown={this.clickItem}
											onMouseEnter={this.hoverItem}>{option.text}
										</p>
									))
								}
							</div>
					</div>
			);
	}
}

export default Autocomplete;



// WEBPACK FOOTER //
// ./src/components/Autocomplete.js